import { formatEntityName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
export const renameEntityStmtInstruction = `
#### Rename Entity
- Syntax: \`rename entity <entity_name> <new_entity_name>;\`
- Example: \`rename entity Book HandBook;\``;
export const stmtRenameEntity = ({ entityName, newEntityName }) => {
    return `rename entity ${entityName} ${newEntityName};`;
};
export const stmtForHumanRenameEntity = ({ entityName, newEntityName }) => {
    return `Rename the database table __${entityName}__ to __${newEntityName}__.`;
};
export const renameEntityHandler = createSchemaStatementHandler({
    type: 'rename entity',
    parse: line => {
        const match = /^rename entity (?<entityName>\w+) (?<newEntityName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'rename entity',
                entityName: formatEntityName(match.groups.entityName),
                newEntityName: formatEntityName(match.groups.newEntityName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanRenameEntity,
    apply: (stmt, builder) => {
        builder.updateSchema(it => it.updateEntityName(stmt.entityName, stmt.newEntityName));
    },
});
//# sourceMappingURL=RenameEntityStmt.js.map